// Scripts librairies
import { docReady } from './js/libs/utils'

// Charge la base commune
require('./common.js')

docReady(function () {
  // gestion des filtres depuis la navbar
  const $mn = document.getElementById('sub-nav')
  const $h = document.getElementById('header')

  if ($mn && $mn.querySelector('.navbar-toggler[data-trigger]')) {
    const openHeader = function () {
      const stickyEl = $mn.closest('.sticky-top')
      if ($h.querySelector('.navbar-collapse').classList.contains('show')) {
        stickyEl.style.zIndex = '999'
      } else {
        stickyEl.style.zIndex = '1010'
      }
    }
    $h.querySelector('.navbar-toggler[data-trigger]').addEventListener(
      'click',
      openHeader
    )
    // $h.querySelector('.navbar-close').addEventListener('click', openHeader)

    const toggleSubnav = function () {
      const stickyEl = $mn.closest('.sticky-top')
      if ($mn.querySelector('.navbar-collapse').classList.contains('show')) {
        stickyEl.style.zIndex = '1010'
        document.getElementById('toHideWhenOpened').classList.add('opacity-0')
      } else {
        stickyEl.style.zIndex = '999'
        document.getElementById('toHideWhenOpened').classList.remove('opacity-0')
        $mn.querySelector('.navbar-close').click()
      }
    }
    $mn
      .querySelector('.navbar-toggler[data-trigger]')
      .addEventListener('click', toggleSubnav)
    $mn.querySelector('.navbar-close').addEventListener('click', toggleSubnav)
    document.querySelector('.navbar-overlay').addEventListener('click', toggleSubnav)
  }

  // auto-anchor
  const target = document.getElementById('detail-terrain-constructible')
  if (target) {
    setTimeout(() => {
      target.scrollIntoView({ behavior: 'smooth' })
    }, 800)
  }

  // auto-anchor
  const target2 = document.getElementById('nos-terrains-a-vendre')
  if (target2) {
    setTimeout(() => {
      target2.scrollIntoView({ behavior: 'smooth' })
    }, 800)
  }
})
